// صفحات سیستمی پوسته: در دست ساخت (placeholder صفحه ماژول)، یافت نشد (STAFF-NOT-FOUND) و خطای Route (STAFF-ERROR).
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from '@phoenix/i18n';
import { EmptyState, ErrorState, ListPage } from '@phoenix/ui';
import { Link as RouterLink, useRouteError } from 'react-router';

/** placeholder صفحه ماژول تا Prompt UI آن (data-screen-id همان شناسه SCR نهایی). */
export function ComingSoonPage({ screenId, titleKey }: { screenId: string; titleKey: string }) {
  return (
    <ListPage screenId={screenId} titleKey={titleKey}>
      <EmptyState
        titleKey="shell:pages.coming_soon.title"
        descriptionKey="shell:pages.coming_soon.description"
      />
    </ListPage>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation('shell');
  return (
    <Box data-screen-id="STAFF-NOT-FOUND">
      <EmptyState
        titleKey="shell:pages.not_found.title"
        descriptionKey="shell:pages.not_found.description"
        action={
          <Button component={RouterLink} to="/" variant="outlined">
            {t('shell:pages.back_home')}
          </Button>
        }
      />
    </Box>
  );
}

/** errorElement روتر: خطای پیش‌بینی‌نشده رندر یا Loader با ErrorState (کد و کد پیگیری). */
export function RouteErrorPage() {
  const error = useRouteError();
  const { t } = useTranslation('shell');
  return (
    <Box data-screen-id="STAFF-ERROR" sx={{ p: 4, maxWidth: 640, mx: 'auto' }}>
      <ErrorState error={error} />
      <Button onClick={() => window.location.assign('/')} variant="outlined">
        {t('shell:pages.back_home')}
      </Button>
    </Box>
  );
}
